import { PhoneIcon } from './Icons';

export function SiteHeader() {
  return (
    <header className="site-header" role="banner">
      <div className="wrap">
        <a
          className="brand"
          href="https://veteransupportservices.com.au/"
          aria-label="Veteran Support Services home"
        >
          <img src="/vss-logo.png" alt="" />
        </a>
        <a
          className="call"
          href="tel:1300931813"
          aria-label="Call our team on 1300 931 813"
        >
          <PhoneIcon />
          <span className="num">1300 931 813</span>
        </a>
      </div>
    </header>
  );
}
